import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { brand, whatsappLink } from '../mock';

const nav = [
  { to: '/', label: 'Home' },
  { to: '/packages', label: 'Packages' },
  { to: '/about', label: 'About' },
  { to: '/#vehicles', label: 'Vehicles' },
  { to: '/#contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (to) => {
    if (to.startsWith('/#')) return false;
    return location.pathname === to;
  };

  return (
    <header className="sticky top-0 z-50 bg-navy/95 backdrop-blur border-b border-white/5" style={{ backgroundColor: 'rgba(6,18,40,0.95)' }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt={brand.name}
            className="h-24 md:h-28 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((n) => (
            n.to.startsWith('/#') ? (
              <a key={n.to} href={n.to.replace('/#', '/#')} className="nav-link">{n.label}</a>
            ) : (
              <NavLink key={n.to} to={n.to} className={({ isActive: a }) => `nav-link ${a ? 'nav-link-active' : ''}`}>{n.label}</NavLink>
            )
          ))}
          <a href={whatsappLink('Hello Goodwishes India Tours, I want tour package details')} target="_blank" rel="noreferrer" className="btn-orange">Get Quote</a>
        </nav>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-navy border-t border-white/5" style={{ backgroundColor: '#061228' }}>
          <div className="px-5 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              n.to.startsWith('/#') ? (
                <a key={n.to} href={n.to} onClick={() => setOpen(false)} className="nav-link py-2">{n.label}</a>
              ) : (
                <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={({ isActive: a }) => `nav-link py-2 ${a && !n.to.startsWith('/#') ? 'nav-link-active' : ''}`}>{n.label}</NavLink>
              )
            ))}
            <a href={whatsappLink('Hello Goodwishes India Tours, I want tour package details')} target="_blank" rel="noreferrer" className="btn-orange text-center">Get Quote</a>
          </div>
        </div>
      )}
    </header>
  );
}
